var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "pointer button-item-handler white--text no-decoration description",
    on: {
      "click": _vm.showCalculationsHistory
    }
  }, [_c('app-icon', {
    attrs: {
      "name": "clock",
      "size": 18
    }
  }), _vm._v(" história ")], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }